import { ErrorBase } from "@util/errors";

export class ExcessBudgetDisabledError extends ErrorBase {
	static errorId = "excess-budget-disabled" as const;
	constructor() {
		super(
			"Der Monat kann nicht geschlossen werden, da es einen Fehler bei der Konfiguration des Überschussbudgets gibt. \n Bitte deaktiviere das Überschussbudget bei den betroffenen Usern oder aktiviere das Überschussbudget in den Standorteinstellungen."
		);
	}
}

export class UnreviewedVouchersError extends ErrorBase {
	static errorId = "unreviewed-vouchers" as const;
	constructor() {
		super(
			"Der Monat kann nicht geschlossen werden, da noch ungeprüfte Belege vorhanden sind. Sobald alle Belege akzeptiert oder abgelehnt worden sind, kannst du den Monat schließen"
		);
	}
}

export class ApprovedDetachedVouchersError extends ErrorBase {
	static errorId = "approved-detached-vouchers" as const;
	constructor() {
		super(
			"Der Monat konnte nicht geschlossen werden aufgrund eines bereits bewilligten Belegs, für den nun kein Budget mehr bereit steht. Problematische Belege erkennen Sie am orangefarbenen Badge „Kein Budget“."
		);
	}
}

export class AccountingMonthIllegalStatusTransitionError extends ErrorBase {
	static errorId = "accounting-month-illegal-status-transition" as const;
	constructor() {
		super(
			"Objekt wurde in der Zwischenzeit geändert, bitte neu laden und nochmal probieren"
		);
	}
}

export class AccountingMonthGapDetectedError extends ErrorBase {
	static errorId = "accounting-month-gap-detected" as const;
	constructor() {
		super(
			"Monatsabschlüsse dürfen keine Lücken aufweisen. Du hast versucht, einen Monat zu schließen oder zu öffnen, nach dem bereits geschlossene Monate folgen. Dies ist nicht erlaubt. Um diese Änderung machen zu können, musst du alle nachfolgenden Monate öffnen."
		);
	}
}

export class WageTypeMissingError extends ErrorBase {
	static fromErrorResponse(payload: any): WageTypeMissingError {
		return new WageTypeMissingError(payload.taxTypeName);
	}

	static errorId = "wage-type-missing" as const;

	override get displayText(): string {
		return `Lohnart nicht gesetzt - ${this.taxTypeName}.`;
	}

	constructor(readonly taxTypeName: string) {
		super();
	}
}

export class WageKeyMissingError extends ErrorBase {
	static fromErrorResponse(payload: any): WageKeyMissingError {
		return new WageKeyMissingError(payload.taxTypeName);
	}

	static errorId = "wage-key-missing" as const;

	override get displayText(): string {
		return `Lohnschlüssel nicht gesetzt - ${this.taxTypeName}.`;
	}

	constructor(readonly taxTypeName: string) {
		super();
	}
}

export class ExpenseAccountMissingError extends ErrorBase {
	static fromErrorResponse(payload: any): ExpenseAccountMissingError {
		return new ExpenseAccountMissingError(payload.taxTypeName);
	}

	static errorId = "expense-account-missing" as const;

	override get displayText(): string {
		return `Aufwandskonto nicht gesetzt - ${this.taxTypeName}.`;
	}

	constructor(readonly taxTypeName: string) {
		super();
	}
}

export class PostingKeyMissingError extends ErrorBase {
	static fromErrorResponse(payload: any): PostingKeyMissingError {
		return new PostingKeyMissingError(payload.postingKeyName);
	}

	static errorId = "posting-key-missing" as const;

	override get displayText(): string {
		return `Buchungsschlüssel nicht gesetzt - ${this.postingKeyName}.`;
	}

	constructor(readonly postingKeyName: string) {
		super();
	}
}

export class InvalidReportSettingsError extends ErrorBase {
	static errorId = "invalid-report-settings" as const;
	constructor() {
		super("Nicht alle verwendeten Lohnarten wurden ausgefüllt");
	}
}

export class PricingSettingNotFoundError extends ErrorBase {
	static fromErrorResponse(payload: any): PricingSettingNotFoundError {
		return new PricingSettingNotFoundError(payload.month);
	}

	static errorId = "pricing-setting-not-found" as const;
	constructor(month: string) {
		super(
			`Keine Honorar-Einstellung deckt den Monat ${month} ab. Passe die Honorar-Einstellungen in den Einstellungen an.`
		);
	}
}
